<nz-spin [nzSpinning]="isLoading" nzTip="Loading music...">
    <div>
        <p bind-innerHTML="htmlCode | uri"></p>
    </div>
</nz-spin>